/**
 * @generated SignedSource<<1dff2c7fa01c6080da6ec4356337f839>>
 * @relayHash 377cef7c9f297de1f7681a17a0293014
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID c82f293dc0324537a9f4e94919117fa39694d9aea069a7e019dd13773038b05a

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { mainIssueAggQuery } from './mainIssueAggQuery.graphql';

const node: PreloadableConcreteRequest<mainIssueAggQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "c82f293dc0324537a9f4e94919117fa39694d9aea069a7e019dd13773038b05a",
    "metadata": {},
    "name": "mainIssueAggQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
